import React, { useState, useRef } from 'react';
import { useParams, useLocation, useSearchParams } from 'react-router-dom';
// import ChatWidget from '../component/ChatWidget/ChatWidget';
import ArrowButton from '../component/Common/ArrowButton';
import TimelineCard from '../component/TimelineCard';
import Navbar from '../component/Navbar/NavbarCommon';
import Footer from '../component/Footer/FooterCommon';

const Timeline: React.FC = () => {
    const { country } = useParams<{ country: string }>();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    
    // Get country name - priority: URL query param > location.state > URL param > default
    const getCountryDisplayName = () => {
        // First check URL query parameter
        const queryCountry = searchParams.get('country');
        if (queryCountry) {
            const countryMap: Record<string, string> = {
                'india': 'India',
                'bangladesh': 'Bangladesh', 
                'sri-lanka': 'Sri Lanka'
            };
            return countryMap[queryCountry.toLowerCase()] || 'India';
        }
        
        // Then check if country name is passed via state (from navbar dropdown)
        if (location.state?.countryName) {
            return location.state.countryName;
        }
        
        // Then check URL parameter and convert to display name
        if (country) {
            const countryMap: Record<string, string> = {
                'india': 'India',
                'bangladesh': 'Bangladesh', 
                'sri-lanka': 'Sri Lanka'
            };
            return countryMap[country.toLowerCase()] || 'India';
        }
        
        // Default fallback
        return 'India';
    };

    const selectedCountry = getCountryDisplayName();

    // Timeline data based on selected country
    const getTimelineData = () => {
        const countryTimelines = {
            'India': [
                {
                    year: "2008",
                    title: "AO Smith begins to market residential & commercial water heaters in India",
                    description: "",
                    image: "assets/india/Pic 1_2008.jpg"
                },
                {
                    year: "2010",
                    title: "AO Smith inaugurates it's first WH manufacturing plant in India",
                    description: "",
                    image: "assets/india/Pic 2_2010.jpeg"
                },
                {
                    year: "2014",
                    title: "AO Smith India inaugurated a Water Treatment plant and R&D labs.",
                    description: "",
                    image: "assets/india/Pic 3_2014.jpg"
                },
                {
                    year: "2015",
                    title: "AO Smith India launched its first residential water purifiers in Delhi & Bangalore.",
                    description: "",
                    image: "assets/india/Pic 4_2015_2.jpg"
                },
                {
                    year: "2018, 2021",
                    title: "WH Break-even - AO Smith India business achieved Break-even",
                    description: "",
                    image: "assets/india/Pic 5_2018_21.JPG"
                },
                 {
                    year: "2021, 2022",
                    title: "Parag amongst “Top 25” leaders in mid-sized companies as “India’s Best Leaders in Times of Crisis 2021",
                    description: "",
                    image: "assets/india/Pic 6_2021_2022.jpg"
                },
                 {
                    year: "2017, 2023",
                    title: "Value Recognition Award Resident’s Safety Award Chairman’s Green Star Award",
                    description: "",
                    image: "assets/india/Pic 7_2017_2023.JPG"
                },
                {
                    year: "2024",
                    title: "AO Smith India marks a milestone: acquiring Pureit from Hindustan Unilever",
                    description: "",
                    image: "assets/india/Pic 9_2024.jfif"
                },

            ],
            'Bangladesh': [
                {
                    year: "2010",
                    title: "Introduced by Unilever as the first automated, affordable household water purifier.",
                    description: "",
                    image: "assets/bangladesh/Picture 1_2010.png"
                },
                {
                    year: "2014",
                    title: "Pureit launches its first ever electric device-Ultima 418",
                    description: "",
                    image: "assets/bangladesh/Picture 2_2014.jpg"
                },
                {
                    year: "2014",
                    title: "Pureit Launched \"Surprise Van\" on World water day-2014",
                    description: "",
                    image: "assets/bangladesh/Picture 3_2014.jpg"
                },
                {
                    year: "2015",
                    title: "Pureit held \"Service camp\" in Dhaka & Chittagong on World Water day-2015",
                    description: "",
                    image: "assets/bangladesh/Picture 4_2015.jpg"
                },
                {
                    year: "2016",
                    title: "Pureit arranged \"Share a meal\" program with Biddyanandafor underprivileged children",
                    description: "",
                    image: "assets/bangladesh/Picture 5_2016.jpg"
                },
                {
                    year: "2018",
                    title: "Pureit Extends its portfolio with new RO based technology ",
                    description: "",
                    image: "assets/bangladesh/Picture 6_2018.jpg"
                },
                {
                    year: "2023",
                    title: "Pureit Won the SDG Brand Awards",
                    description: "",
                    image: "assets/bangladesh/Picture 7_2023.jfif"
                },
                  {
                    year: "2024",
                    title: "AO Smith Bangladesh Private Limited acquires Pureit Business In Bangladesh.",
                    description: "",
                    image: "assets/bangladesh/Picture 8_2024.png"
                },
                  {
                    year: "2025",
                    title: "New electric device launched –Marina & Wave",
                    description: "",
                    image: "assets/bangladesh/Picture 9_2025.jpg"
                }
            ],
            'Sri Lanka': [
                {
                    year: "2009",
                    title: "Pureit launches operations in Sri Lanka",
                    description: "",
                    image: "assets/srilanka/Picture 1_2009.png"
                },
                {
                    year: "2015",
                    title: "First authorized dealer network \"Abans PLC\" established",
                    description: "",
                    image: "assets/srilanka/Picture 2_2018.png"
                },
                {
                    year: "2018",
                    title: "Pureit Sri Lanka introduces energy-efficient models",
                    description: "",
                    image: "assets/srilanka/Picture 3_2018.jpg"
                },
                {
                    year: "2022",
                    title: "Expansion to major cities across Sri Lanka",
                    description: "",
                    image: "assets/srilanka/Picture 4_2022.jpg"
                },
                {
                    year: "2024",
                    title: "Pureit Sri Lanka reaches 10,000+ satisfied customers",
                    description: "",
                    image: "assets/srilanka/Picture 5_2024.jpg"
                }
            ]
        };

        return countryTimelines[selectedCountry as keyof typeof countryTimelines] || countryTimelines['India'];
    };

    const timelineData = getTimelineData();

    // Horizontal scroll functionality
    const scrollContainerRef = useRef<HTMLDivElement>(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(true);

    const checkScrollButtons = () => {
        const container = scrollContainerRef.current;
        if (container) {
            setCanScrollLeft(container.scrollLeft > 0);
            setCanScrollRight(
                container.scrollLeft < container.scrollWidth - container.clientWidth - 1
            );
        }
    };

    const scrollLeft = () => {
        const container = scrollContainerRef.current;
        if (container) {
            const scrollAmount = container.clientWidth * 0.8;
            container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        }
    };

    const scrollRight = () => {
        const container = scrollContainerRef.current;
        if (container) {
            const scrollAmount = container.clientWidth * 0.8;
            container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
    };

    React.useEffect(() => {
        checkScrollButtons();
        const container = scrollContainerRef.current;
        if (container) {
            container.addEventListener('scroll', checkScrollButtons);
            window.addEventListener('resize', checkScrollButtons);
            return () => {
                container.removeEventListener('scroll', checkScrollButtons);
                window.removeEventListener('resize', checkScrollButtons);
            };
        }
    }, [timelineData]);

    return (
        <div className="min-h-screen bg-white relative">
            <Navbar />
            {/* Navigation */}

            {/* Main Content */}
            <div className="pt-20 lg:pt-28 px-5 lg:px-10 mt-5">
                {/* Back Arrow */}
                <div className='mx-auto max-w-8xl'>
                    <div className="mb-6">
                        <ArrowButton />
                    </div>

                    {/* Header - This line changes based on selected country */}
                    <div className="mb-11">
                        <h1 className="text-4xl lg:text-5xl xl:text-6xl font-semibold text-black mb-2">
                            <span className="text-navgreen">AO</span> Smith {selectedCountry} Journey
                        </h1>
                        <p className="text-lg lg:text-xl xl:text-2xl text-deepTeal font-medium">
                            A timeline of innovation, growth, and excellence.
                        </p>
                    </div>

                    {/* Timeline Container */}
                    <div className="relative pb-20">
                        {/* Horizontal Scrollable Timeline */}
                        <div className="relative">
                            {/* Left Arrow */}
                            {canScrollLeft && (
                                <button
                                    onClick={scrollLeft}
                                    className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-white rounded-full p-3 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-200"
                                    aria-label="Scroll left"
                                >
                                                                       <svg
                                        className="w-6 h-6 text-navgreen"
                                        fill="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path d="M8.5 12L13.5 7L14.4 7.9L10.3 12L14.4 16.1L13.5 17L8.5 12Z"/>
                                    </svg>
                                </button>
                            )}

                            {/* Right Arrow */}
                            {canScrollRight && (
                                <button
                                    onClick={scrollRight}
                                    className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-white rounded-full p-3 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-200"
                                    aria-label="Scroll right"
                                >
                                     <svg
                                        className="w-6 h-6 text-navgreen transform rotate-180"
                                        fill="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path d="M8.5 12L13.5 7L14.4 7.9L10.3 12L14.4 16.1L13.5 17L8.5 12Z"/>
                                    </svg>

                                </button>
                            )}

                            {/* Scrollable Container */}
                            <div
                                ref={scrollContainerRef}
                                className="flex gap-6 lg:gap-11 overflow-x-auto scrollbar-hide pb-4"
                                style={{
                                    scrollbarWidth: 'none',
                                    msOverflowStyle: 'none'
                                }}
                            >
                                {timelineData.map((item, index) => (
                                    <div key={item.year} className="relative flex-shrink-0 w-72 sm:w-80 lg:w-64">
                                        <TimelineCard
                                            year={item.year}
                                            title={item.title}
                                            description={item.description}
                                            image={item.image}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Chat Widget */} 
                <div className='bottom-[20px]'>
                    {/* <ChatWidget /> */}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Timeline;